$(() => {
    if($('body').hasClass('pageScroll')){
        new pageScroll();
    }
});

class pageScroll {

    constructor() {
        this.isTouchDevice = this.isTouchDevice();
        this.contoller = new ScrollMagic.Controller();
        this.sectionHeight = this.getSectionHeight();
        this.scrollNavigation = $('#scrollNavigation');
        this.typeBox = new typeBox();

        if($(window).width() >= 1024){
            this.isMobile = false;
        }else{
            this.isMobile = true;
        }

        this.checkBodyPosition();
        this.scenes();
    }

    isTouchDevice() {
        var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
        var mq = function (query) {
            return window.matchMedia(query).matches;
        };

        if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
            return true;
        }

        // include the 'heartz' as a way to have a non matching MQ to help terminate the join
        // https://git.io/vznFH
        var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
        return mq(query);
    }

    scenes() {
        this.scene1();

        if(this.isMobile === false){
            this.scene2();
            this.scene3();
            this.scene4();
        }

        this.navigation();
        this.showScrollNav();
    }

    updateBodyPosition(position){
        if(this.getBodyPosition() !== position){
            $('body').attr('data-position', position);
            this.updateScrollnav(position);
        }
    }

    updateScrollnav(position){
        this.scrollNavigation.find('button').removeClass('isActive');
        $('#scrollNavigation-' + position).addClass('isActive');
    }

    getBodyPosition() {
        return $('body').attr('data-position')
    }

    scene1() {
        let line = $("#section1 .section-image path");
        let timeline = new TimelineMax();
        timeline.set("#section1 .section-image path", {
            yPercent: 100,
        });

        for (let i = 0; i < line.length; i++) {
            if (i === 0) {
                timeline.to(line[i], .3, {
                    yPercent: 0,
                    opacity: 1
                }, .3);
            } else {
                timeline.to(line[i], .3, {
                    yPercent: 0,
                    opacity: 1
                }, "-=.15");
            }

        }

        timeline.to("#section1 .section-title", 1, {
            opacity: 1
        }, .1);
    }

    scene2() {
        let animation = new TimelineMax();

        animation.fromTo("#section2 .line", 5,
            {
                scaleY: 0
            }, {
                scaleY: 1
            });

        animation.fromTo("#section2 .cross1", 1,
            {
                opacity: 0
            }, {
                opacity: 1
            }, '-=.5');

        animation.fromTo("#section2 .cross2", 1,
            {
                opacity: 0
            }, {
                opacity: 1
            }, '-=.5');

        animation.fromTo("#section2 .cross3", 1,
            {
                opacity: 0
            }, {
                opacity: 1
            }, '-=.5');

        animation.fromTo("#section2 .section-title", 1,
            {
                opacity: 0
            }, {
                opacity: 1
            });

        new ScrollMagic.Scene({
            triggerElement: '#section2',
            duration: '50%',
            triggerHook: .5
        })
            .addTo(this.contoller)
            .setTween(animation)
        // .addIndicators({
        //     name: "Scene 2",
        //     colorTrigger: "white",
        //     colorStart: "white",
        //     colorEnd: "white"
        // });
    }

    scene3() {
        let animation = new TimelineMax();

        animation.fromTo("#section3 .line1", 2,
            {
                scaleY: 0
            }, {
                scaleY: 1
            }, 1);

        animation.fromTo("#section3 .line2", 2,
            {
                scaleY: 0
            }, {
                scaleY: 1
            }, '-=.5');

        animation.fromTo("#section3 .line3", 2,
            {
                scaleY: 0
            }, {
                scaleY: 1
            }, '-=.5');

        animation.fromTo("#section3 .section-title", 1,
            {
                opacity: 0
            }, {
                opacity: 1
            });

        new ScrollMagic.Scene({
            triggerElement: '#section3',
            duration: '50%',
            triggerHook: .5
        })
            .addTo(this.contoller)
            .setTween(animation)
        // .addIndicators({
        //     name: "Scene 3",
        //     colorTrigger: "white",
        //     colorStart: "white",
        //     colorEnd: "white"
        // });
    }

    scene4() {
        let animation = new TimelineMax();

        animation.fromTo("#section4 .screen1", 2,
            {
                opacity: 0
            }, {
                opacity: 1
            }, 1);

        animation.fromTo("#section4 .line1", 2,
            {
                opacity: 0
            }, {
                opacity: 1
            }, '-=.5');

        animation.fromTo("#section4 .screen2", 2,
            {
                opacity: 0
            }, {
                opacity: 1
            }, '-=.5');

        animation.fromTo("#section4 .screen3", 2,
            {
                opacity: 0
            }, {
                opacity: 1
            }, '-=1.5');

        animation.fromTo("#section4 .section-title", 1,
            {
                opacity: 0
            }, {
                opacity: 1
            });

        new ScrollMagic.Scene({
            triggerElement: '#section4',
            duration: '50%',
            triggerHook: .5
        })
            .addTo(this.contoller)
            .setTween(animation)
        // .addIndicators({
        //     name: "Scene 4",
        //     colorTrigger: "white",
        //     colorStart: "white",
        //     colorEnd: "white"
        // });
    }

    checkBodyPosition(){
        let scrollTop = $(window).scrollTop();

        if (scrollTop < this.sectionHeight) {
            this.updateBodyPosition('section1');
        } else if (scrollTop >= this.sectionHeight && scrollTop < this.sectionHeight * 2) {
            this.updateBodyPosition('section2');
        } else if (scrollTop >= this.sectionHeight * 2 && scrollTop < this.sectionHeight * 3) {
            this.updateBodyPosition('section3');
        } else if (scrollTop >= this.sectionHeight * 3 && scrollTop < this.sectionHeight * 3.3) {
            this.updateBodyPosition('section4');
        } else {
            let headerHeight = $('#pageHeader').height();
            scrollTop = scrollTop + headerHeight;
            if (scrollTop >= $('#funkce').offset().top && scrollTop < $('#reference').offset().top) {
                this.updateBodyPosition('funkce');

                // disable demo on mobile and touch devices
                if(this.isTouchDevice || $(window).width() < 1024){
                    // this.typeBox.wasDemoPalyed = true;
                }

                if(this.typeBox.wasDemoPalyed === false){
                    this.typeBox.wasDemoPalyed = true;
                    this.typeBox.demo();
                }else{
                    this.typeBox.activate();
                }

            } else if (scrollTop >= $('#reference').offset().top) {
                this.updateBodyPosition('reference');
            }
        }
    }

    navigation() {

        $(window).on('scroll', () => {
            this.checkBodyPosition();
        });

    }

    showScrollNav() {
        $(window).on('scroll load', () => {
            const scrollTop = $(window).scrollTop();
            let trigger = 3.3;
            if ($(window).outerHeight() > $(window).outerWidth()) {
                trigger = 3;
            }

            if (scrollTop <= this.sectionHeight * trigger) {
                this.scrollNavigation.removeClass('isHidden');
            } else {
                this.scrollNavigation.addClass('isHidden');
            }
        });
    }

    getSectionHeight() {
        return $('.section').height();
    };
}